export const DELETION_STATUS_PATH = "/deletion-status";

/** Build a shareable URL to check data deletion status (code optional). */
export function buildDeletionStatusUrl(code, origin = typeof window !== "undefined" ? window.location.origin : "") {
    const base = `${origin}${DELETION_STATUS_PATH}`;
    const trimmed = code != null ? String(code).trim() : "";
    if (!trimmed) return base;
    return `${base}/${encodeURIComponent(trimmed)}`;
}
